module.exports = __webpack_public_path__ + "img/task-banner.ea92b80b-p-130x130q80.ba8754e8.png";